import {makeReactContext} from 'lib/makeReactContext';

import {CustomMappingData} from './processFlowchartConfigEditorConstants';

export type CustomMappingContextValue = Record<string, CustomMappingData>;

/** Context to provide custom mapping data by edge ID */
export const CustomMappingContext = makeReactContext<CustomMappingContextValue>(
  () => ({}),
  'CustomMappingContext'
);
